import type { MouseEvent } from 'react';

export const SECTION_HIGHLIGHT_CLASS = 'lp-section-highlight';
const SECTION_HIGHLIGHT_MS = 1600;
const highlightTimers = new WeakMap<HTMLElement, number>();

/**
 * Mark the section a link just pointed at. The contact section sits directly
 * above the footer, so from the footer (or a header click at the bottom of the
 * page) it is already on screen and the scroll moves nothing; the CSS tint on
 * this class shows the click landed. Removed by timer, not animationend, so it
 * also clears under prefers-reduced-motion, where the tint is static.
 */
function highlightSection(target: HTMLElement): void {
  window.clearTimeout(highlightTimers.get(target));
  target.classList.remove(SECTION_HIGHLIGHT_CLASS);
  void target.offsetWidth; // restart the animation on a repeat click
  target.classList.add(SECTION_HIGHLIGHT_CLASS);
  highlightTimers.set(
    target,
    window.setTimeout(() => target.classList.remove(SECTION_HIGHLIGHT_CLASS), SECTION_HIGHLIGHT_MS)
  );
}

/**
 * Smooth-scroll to a section on the current page. Returns true when the target
 * exists, so callers can prevent the default hash navigation; otherwise the
 * browser (or React Router) handles the link normally.
 */
export function scrollToSection(id: string): boolean {
  if (typeof document === 'undefined') return false;
  const target = document.getElementById(id);
  if (!target) return false;
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  highlightSection(target);
  return true;
}

/** onClick helper for in-page anchors (`#section`). */
export function handleSectionClick(event: MouseEvent<HTMLAnchorElement>, id: string): void {
  if (scrollToSection(id)) {
    event.preventDefault();
  }
}
